import React from "react"
import {resourceTypeFormatting} from "../../tevapi/io";
import {Breadcrumb} from "antd";
import { PolymorphicItem, IDeliveredSignal, IAtlasSignal } from "../../tevapi/interfaces";

export const ItemCrumbs: React.FC<{item: PolymorphicItem}> = ({item}) => {
  const humanReadibleType: string = resourceTypeFormatting(
    item.resourcetype
  );

  const crumbs = [{
    title: humanReadibleType,
  }];

  if (item.unique_for !== null) {
    crumbs.push({
      title: (
        <a href={`/collections/${item.unique_for.pk}/`}>
          {item.unique_for.name}
        </a>
      ),
    });
  }

  if ("host_star" in item) {
    crumbs.push({
      title: (
        <a href={`/items/${item.host_star.pk}/`}>
          {item.host_star.slug}
        </a>
      ),
    });
  }

  crumbs.push({title: item.slug.toString()});

  return (
    <Breadcrumb items={crumbs} />
  );
};
